import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f64dab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feature d-flex flex-column flex-md-row" }
const _hoisted_2 = { class: "feature-right" }
const _hoisted_3 = { class: "d-flex flex-column flex-md-row feature-box align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature-left" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Features"),
  /*#__PURE__*/_createElementVNode("p", null, "We have added functions that woud make banking more easy for you.")
], -1))
const _hoisted_5 = { class: "d-flex flex-column flex-md-row feature-box align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_features_box = _resolveComponent("features-box")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features1, (feature) => {
          return (_openBlock(), _createBlock(_component_features_box, {
            key: feature.icon,
            para: feature.para,
            heading: feature.heading,
            icon: feature.icon,
            isRight: feature.right
          }, null, 8, ["para", "heading", "icon", "isRight"]))
        }), 128))
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features2, (feature) => {
          return (_openBlock(), _createBlock(_component_features_box, {
            key: feature.icon,
            para: feature.para,
            heading: feature.heading,
            icon: feature.icon,
            isRight: feature.right
          }, null, 8, ["para", "heading", "icon", "isRight"]))
        }), 128))
      ])
    ])
  ]))
}